module.exports = __webpack_public_path__ + "media/stylesheets/images/logo2-71c7ae5b33cc87774bc2bb2042a4b412.jpg";